import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=ef5dd25a&scoped=true"
import script from "./confirm-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-dialog.vue?vue&type=script&lang=js"
import style0 from "./confirm-dialog.vue?vue&type=style&index=0&id=ef5dd25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5dd25a",
  null
  
)

export default component.exports